export const CARD_ANIMATION_DURATION_MS = 550;
